export default {
  type: 'editor.elements.CrossSellGalleryElement',
  name: 'Cross Sell',
  editModeTitle: 'Edit cross sell',
  icon: 'M18,6V17H22V6M2,17H6V6H2M7,19H17V4H7V19Z',
  order: 120,
  tooltip: 'The cross-selling gallery helps you promote your other items and increase sales.',
};
